import { delay, select } from 'redux-saga/effects';
import { NetworkError, TimeoutError } from 'api/apiClient';
import { getIsOnline } from 'store/connection/selectors';

export const RETRY_MAX_ATTEMPTS = 2;
export const RETRY_DELAYS_MS = [2000, 4000];

export function* withRetry<T>(
  fn: () => Promise<T>,
): Generator<unknown, T, T | boolean> {
  for (let attempt = 0; attempt <= RETRY_MAX_ATTEMPTS; attempt++) {
    try {
      return (yield fn()) as T;
    } catch (err) {
      const isTransient =
        err instanceof NetworkError || err instanceof TimeoutError;
      if (!isTransient || attempt === RETRY_MAX_ATTEMPTS) throw err;
      const isOnline = (yield select(getIsOnline)) as boolean;
      if (!isOnline) throw err;
      yield delay(RETRY_DELAYS_MS[attempt] + Math.floor(Math.random() * 1000));
    }
  }
  throw new Error('unreachable');
}
